<mat-card appearance="outlined">
  <mat-card-title [innerText]=" cardTitle | translate"></mat-card-title>
  <mat-card-content [formGroup]="formGroupEinsatz">
    <span class="row">
      <mat-form-field>
        <mat-label> {{ "MAIN_APP_AUSMASS.objekt" | translate }} </mat-label>
        <input type="text" placeholder="Objekt wählen" aria-label="Suche" matInput formControlName="fldObjekt" [matAutocomplete]="auto" required />
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="getObjektDesc" (optionSelected)="selectedSearchItem($event)">
          <mat-option *ngFor="let objekt of filteredDescriptions | async" [value]="objekt">
            {{ objekt.beschreibung }}
          </mat-option>
        </mat-autocomplete>
        <mat-hint align="end">Für die Wildcard-Suche die Eigabe mit * beginnen</mat-hint>
      </mat-form-field>

      <mat-form-field>
        <mat-label> {{ "MAIN_APP_SERVICE_APP.datum" | translate }} </mat-label>
        <input matInput [matDatepicker]="pickerStart" formControlName="fldDatum" required />
        <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
        <mat-datepicker #pickerStart></mat-datepicker>
      </mat-form-field>
    </span>

    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_SERVICE_APP.startzeit" | translate }}</mat-label>
        <input type="time" matInput formControlName="fldStartZeit" required />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "MAIN_APP_SERVICE_APP.endzeit" | translate }}</mat-label>
        <input type="time" matInput formControlName="fldEndZeit" required />
      </mat-form-field>
    </span>
  </mat-card-content>

  <mat-dialog-actions>
	  <button (click)="save()" [disabled]="!formGroupEinsatz.valid" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-stroked-button></button>
    <button mat-stroked-button class="cancel" mat-dialog-close [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate"></button>
  </mat-dialog-actions>
</mat-card>
